import { Nomination } from 'components/award/nomination/Nomination'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { BannerSectionContainer } from './banner-section/BannerSectionContainer'
import { BrandSectionContainer } from './brand-section/BrandSectionContainer'
import { CategorySectionContainer } from './category-section/CategorySectionContainer'
import { VideoSectionContainer } from './video-section/VideoSectionContainer'

const NOMINATION_TAB_LIST = ['banner', 'category', 'brand', 'video']

const TAB_CONTENT = {
    banner: <BannerSectionContainer />,
    category: <CategorySectionContainer />,
    brand: <BrandSectionContainer />,
    video: <VideoSectionContainer />,
}

export const NominationContainer = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const sectionName = searchParams.get('sectionName')

    const onChangeSidebar = (item) => {
        navigate(`/awards/nomination?sectionName=${item}`)
    }

    const props = {
        options: NOMINATION_TAB_LIST,
        content: TAB_CONTENT,
        activeSidebar: sectionName || 'banner',
        onChangeSidebar,
    }

    return <Nomination {...props} />
}
